/*******************************************************************************
 * Copyright     : Copyright (c)  2020 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          : SoftwareFeaturesItemSelect.tsx
 *
 * Project Title : RDR7000
 *
 * Description   : Software Features Item Custom Select component
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : Amol Jagtap (H409453)
 *
 * @Date         : Aug 15, 2020
 *
 * @Version      : Version 1.0
 *
 * By            : Amol Jagtap (H409453)
 * On            : Aug 15, 2020
 * Description   : Create custom component for Select to be used in Software Features accordion
 *
 *
 ******************************************************************************/

import React, { FC } from 'react';
import { Select, InputLabel } from '@scuf/common';
import { ISoftwareFeaturesSelectProps } from './ISoftwareFeaturesItemProps';

export const SoftwareFeaturesItemSelect: FC<ISoftwareFeaturesSelectProps> = ({
  name,
  label,
  value,
  disabled,
  dataset,
  onChange,
}) => {
  const options = dataset.map((item: string) => ({
    value: item,
    text: item,
  }));

  return (
    <>
      <InputLabel label={label} />
      <Select
        placeholder={options[0].text}
        options={options}
        onChange={currentValue => onChange(name, currentValue)}
        value={value}
        disabled={disabled}
      />
    </>
  );
};
